import { supabase } from '@/supabase';
import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        isLoggedIn: false
    }),

    actions: {
        async init() {
            const { data } = await supabase.auth.getSession();

            this.user = data.session?.user || null;
            this.isLoggedIn = !!data.session || this.hasLocalSession();

            supabase.auth.onAuthStateChange((event, session) => {
                // Prevent automatic logout - keep session from localStorage
                if (event === 'SIGNED_OUT' || !session) {
                    if (this.hasLocalSession()) {
                        // Restore session from localStorage instead of logging out
                        this.isLoggedIn = true;
                        return;
                    }
                }

                this.user = session?.user || null;
                this.isLoggedIn = !!session || this.hasLocalSession();
            });
        },

        hasLocalSession() {
            // Check if we have stored auth data in localStorage
            const localToken = localStorage.getItem('access_token');
            const localUserId = localStorage.getItem('user_id');
            const localRole = localStorage.getItem('role');
            return !!(localToken && localUserId && localRole);
        },

        async restoreSession() {
            // Attempt to restore Supabase session from localStorage
            const { data, error } = await supabase.auth.getSession();
            if (data.session) {
                this.user = data.session.user;
                this.isLoggedIn = true;
                return true;
            }
            return this.hasLocalSession();
        }
    }
});